// eslint-disable-next-line import/prefer-default-export
export const SET_JOBS_LIST = 'SET_JOBS_LIST';
export const SET_JOB_INFO = 'SET_JOB_INFO';
